import './navbar.scss';

import { faTimes, faUser } from '@fortawesome/free-solid-svg-icons';
import { AuthService, User, userSelectors } from '@skinsoft/auth';
import { ReactiveVue } from '@skinsoft/reactive-vue';
import { Touchable } from '@skinsoft/ui';
import * as emojiFlags from 'emoji-flags'

import { Component, Watch } from 'vue-property-decorator';

import { WorkspaceDataStore, workspaceSelectors } from '@skinsoft/entity';
import { ContextMenuModal } from './context-menu-modal';

declare var WORKSPACE_ID: string;


@Component({
    components: {
        sContextMenuModal: ContextMenuModal,
        sTouchable: Touchable,
    },
    props: ['title'],
    template: require('./navbar.html'),
})
export class Navbar extends ReactiveVue {
    public $authService: AuthService;
    public title: string;

    public $refs: {
        modal: ContextMenuModal;
        navbar: HTMLElement;
    };

    public user: User | null = null;
    public userIcon = faUser;
    public logOutIcon = faTimes;
    public userSelectors = userSelectors;
    private localeFlag: string | null = null;

    private $workspaceDataStore: WorkspaceDataStore;
    private workspaceTitle = "";

    public created() {
        this.subscribeTo(this.$authService.waitForUser$(), this.onUser);
    }

    public logOut() {
        if (!confirm(this.$t('navbar.logout') as string)) {
            return;
        }

        return this.$authService.logOut();
    }

    public onTouchTimed = () => {
        this.$refs.modal.open();
    };

    private onUser(user: User | null) {
        this.user = user;
        if (user) {
            this.subscribeTo(this.$workspaceDataStore.fetchOne(WORKSPACE_ID),
                ws => {
                    this.workspaceTitle = workspaceSelectors.name(ws, this.$i18n.locale);
                })
        }
    }

    @Watch('$i18n.locale', { immediate: true })
    private onLocaleChange() {
        // If the locale name doesn't correspond to the country code, specify it in the locale file (ex : fr-ca => ca)
        const countryCode = this.$t('countryCode');
        const localeId = countryCode !== 'countryCode' ? countryCode : this.$i18n.locale;
        const code = emojiFlags.countryCode(localeId);
        this.localeFlag = code ? code.emoji : null;
    }
}
